import i18n from "../i18n/config";
import { normalizeApiErrorBody } from "./channelSaveError";
import { translateApiPayload } from "./translateApiError";

/**
 * Tradução opcional da linha "próximo passo" (`*_action` no namespace errors).
 * @param {string | null} code
 * @param {Record<string, unknown>} params
 * @returns {string | null}
 */
export function translateErrorActionForCode(code, params = {}) {
  if (!code || typeof code !== "string" || !code.startsWith("errors.")) return null;
  const sub = code.slice("errors.".length);
  const actionKey = `${sub}_action`;
  const t = i18n.t(actionKey, { ns: "errors", ...params });
  if (!t || t === actionKey) return null;
  return t;
}

/**
 * Extrai mensagem amigável + ação opcional + debug de integração (só master, vindo da API).
 * @param {unknown} error — Axios error ou objeto `{ message, code, ... }` de fetchData
 * @returns {{
 *   message: string,
 *   action: string | null,
 *   code: string | null,
 *   integrationDebug: object | null,
 *   raw: object,
 * }}
 */
export function getUserFacingApiMessage(error) {
  const raw = normalizeApiErrorBody(error);
  const code = typeof raw.code === "string" ? raw.code : null;
  const params = raw.params && typeof raw.params === "object" ? { ...raw.params } : {};

  const fromCode = translateApiPayload({ code, params });
  const fromActionI18n = translateErrorActionForCode(code, params);

  const rawMessage =
    (typeof raw.message === "string" && raw.message.trim()) ||
    (Array.isArray(raw.message) && typeof raw.message[0] === "string" && raw.message[0]) ||
    null;

  const message = fromCode || rawMessage || "Não foi possível concluir a operação.";

  const action =
    fromActionI18n ||
    (typeof raw.userAction === "string" && raw.userAction.trim() ? raw.userAction.trim() : null);

  const integrationDebug =
    raw.integrationDebug && typeof raw.integrationDebug === "object" ? raw.integrationDebug : null;

  return { message, action, code, integrationDebug, raw };
}
